module.exports = __webpack_public_path__ + "img/roundClose.png?f1e4561d0756a3624d37df4fa0c6f43c";